package co.maytes.standupbot.dashboard.features.settings

import kotlinx.browser.window

internal fun copyTextToClipboard(value: String): Boolean =
    try {
        val navigator: dynamic = window.navigator
        val clipboard = navigator.clipboard
        if (clipboard != null && clipboard != js("undefined")) {
            clipboard.writeText(value)
            true
        } else {
            false
        }
    } catch (_: Throwable) {
        false
    }
